module.exports = __webpack_public_path__ + "img/c1af8ab.jpg";